export class DocumentView {
  constructor(public readonly fileName: string, public readonly publicUrl: string) {}
}
